import XCircleIcon from "assets/icon/XCircleIcon";

export default function PageNotFound(){
    return(
        <div className="h-full w-full flex flex-col gap-6 items-center justify-center">
            <div>
                <XCircleIcon className="w-24 fill-red-800" />
            </div>
            <div className="flex flex-col items-center">
                <span className="font-semibold text-3xl ">Page Not Found</span>
                <span>Oops.. The page you requested could not be found.</span>
            </div>
        </div>
    )
}